import { useMachine } from '@xstate/react';
import { useState } from 'react';
import { userAgent } from '@tink/tink-link-core/src/user-agent-detector';
import {
  createTPRedirectMachine,
  TPRedirectMachineContext,
} from '../machines/TPRedirectMachine/TPRedirectMachine';
import { useConfiguration } from '../../components/ApplicationProviders/ConfigurationProvider/ConfigurationProvider';

export type UseTPRedirectMachineProps = Pick<TPRedirectMachineContext, 'credentials'>;

export const useTPRedirectMachine = ({ credentials }: UseTPRedirectMachineProps) => {
  const { data } = useConfiguration();
  const [machine] = useState(
    createTPRedirectMachine({
      initialContext: { credentials },
      isDesktop: userAgent.isDesktop,
      configuration: data,
    })
  );

  return useMachine(machine);
};
